<template>
  <div class="pageContent">
    <!-- 云闪付小程序登录页面 -->
    <div id="HelloWorld" v-if="ysf">
      <!-- v-if="cardNo == '' "-->
      <div class="pages">
        <div class="btn-box">
          <UPButton id="btnLogin" @click="btnClick" :scope="scope">
            一键登录
          </UPButton>
        </div>
        <div class="loading" v-if="btLoading" id="circle"></div>
        <!-- <Button id="btnClick" @click="btnClick">跳转i站</Button> -->
        <!-- <router-link to="B">跳转 </router-link> -->
      </div>
    </div>
    <!-- 正常H5登录页面 -->
    <div>
      <!--顶部一条-->
      <mu-appbar>
        <!--返回上一层-->
        <span class="topT">会员登录</span>
        <!--<mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />-->
        <!--<mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />-->
      </mu-appbar>

      <!-- <div style="color: #FFFFFF;    font-size: 0.42rem;    position: relative;    top: 4px;">
    会员登录
  </div> -->

      <br />

      <div class="bigpage">
        <!--常规登录页 + 快捷登录页-->
        <mu-tabs :value="activeTab" @change="handleTabChange">
          <mu-tab value="tab1" title="普通登录" style="font-size: 120%" />
          <mu-tab value="tab2" title="快捷登录" style="font-size: 120%" />
        </mu-tabs>

        <!--普通登录-->
        <div v-if="activeTab === 'tab1'">
          <div align="left" style="margin-top: 2vh; lign-height: 1.5">
            <!--<mu-divider class="dividerClass"/>-->

            <mu-text-field
              hintText="卡号/手机号/邮箱"
              type="text"
              icon="smartphone"
              v-model="UserName"
              fullWidth=""
              style="margin-left: -4%; width: 103%"
            />
            <mu-text-field
              hintText="请输入密码"
              type="password"
              icon="lock"
              v-model="UserPass"
              fullWidth=""
              style="margin-left: -4%; width: 103%"
            />

            <nobr id="FJMPart" v-if="FJMPD">
              <!--图片附加码     只有在三次输入错误之后才会显示-->
              <mu-text-field
                hintText="请输入附加码"
                type="text"
                icon="location_city"
                v-model="FJM1"
                style="margin-left: -4%; width: 69%"
              />
              <img
                v-bind:src="TPFJM"
                style="width: 27%; margin-left: 2%; margin-top: -0.1rem"
                v-on:click="this.getValidateCode"
                align="right"
              />
            </nobr>
          </div>

          <mu-raised-button
            label="登 录"
            primary=""
            @click="Login1"
            v-bind:style="{ width: '100%', height: '0.8rem' }"
            style="font-size: 0.3rem; margin-top: 0.2rem"
          />
        </div>
        <!--普通登录  END-->

        <!--快捷登录-->
        <div v-if="activeTab === 'tab2'">
          <div align="left" style="margin-top: 2vh">
            <!--<mu-divider class="dividerClass"/>-->
            <mu-text-field
              hintText="请输入手机号"
              type="text"
              icon="smartphone"
              v-model="UserPhone"
              fullWidth=""
              style="margin-left: -4%; width: 103%"
            />
            <nobr>
              <!--图片附加码-->
              <mu-text-field
                hintText="请输入附加码"
                type="text"
                icon="vpn_key"
                v-model="FJM1"
                class="txtValidate"
                style="margin-left: -4%; width: 69%; display: none"
              />
              <img
                v-bind:src="TPFJM"
                style="
                  width: 30%;
                  float: right;
                  margin-top: -0.1rem;
                  display: none;
                "
                v-on:click="this.getValidateCode"
              />
            </nobr>

            <nobr>
              <mu-text-field
                hintText="请输入手机验证码"
                type="text"
                icon="verified_user"
                v-model="YZM"
                class="txtValidate"
                style="margin-left: -4%; width: 69%; z-index: 1"
              />
              <span v-show="haveYZM == false">
                <input
                  type="button"
                  id="j-popup"
                  @click="NetEaseDunClick"
                  value="获取"
                  style="
                    font-size: 0.3rem;
                    float: right;
                    background-color: #27ba69;
                    height: 0.7rem;
                    border: none;
                    width: 30%;
                    color: white;
                  "
                />
              </span>
              <span v-show="haveYZM == true">
                <input
                  type="button"
                  v-model="WaitTime"
                  style="
                    font-size: 0.32rem;
                    float: right;
                    background-color: #eeeeee;
                    height: 0.7rem;
                    border: none;
                    width: 30%;
                    color: #999;
                  "
                />
              </span>
            </nobr>
          </div>

          <mu-raised-button
            label="登录/注册"
            primary=""
            @click="QuickLogin"
            v-bind:style="{ width: '100%', height: '0.8rem' }"
            style="font-size: 0.3rem; margin-top: 0.2rem"
          />
        </div>
        <!--快捷登录  end-->

        <!--下方通用-->
        <div style="height: 0.2rem"></div>
        <div
          style="
            border: 1px solid #27ba69;
            padding: 0.15rem;
            border-radius: 3px;
          "
        >
          <router-link
            slot="left"
            to="/user/OtherUser"
            style="font-size: 0.3rem"
          >
            非会员/协议预订订单查询
          </router-link>
        </div>

        <div style="height: 0.46rem"></div>
        <router-link to="/user/Register" class="Grey">
          <span style="float: left; font-size: 0.3rem; color: #999">
            注册账号
          </span>
        </router-link>

        <router-link to="/user/ForgotPass" class="Grey">
          <span style="float: right; font-size: 0.3rem; color: #999">
            忘记密码
          </span>
        </router-link>
      </div>

      <div class="unionLogin">
        <div class="top">
          <div class="line"></div>
          <div>合作网站账号登录</div>
          <div class="line"></div>
        </div>
        <div class="btns">
          <a :href="urls.QQ">
            <img src="../../../../static/user/unionLogin/login_qq.png" />
          </a>
          <!--<a :href='urls.WeiXin'><img class='center' src='../../../../static/user/unionLogin/login_wechat.png' /></a>
        <a :href="urls.ALi"><img src='../../../../static/user/unionLogin/login_alipay.png' /></a>-->
        </div>
      </div>
      <!--下方通用  END-->
      <mu-toast
        v-if="toast"
        v-bind:message="TellUser"
        @close="hideToast"
        id="alertline"
      />
      <div id="captcha"></div>
      <!-- <pop :display='popDisplayA' @closeHandler='closePop' @okHandler='closeYESA' title='提示' :msg='popMsg' :onlyOk='popOnlyOk' /> -->
    </div>

    <div v-if="showVerifyCode" style="width:100vw;height:100vh;background-color:rgba(0,0,0,0.5);position:fixed;top:0;left:0;z-index: 9;" @click="hideModal">
        <div style="padding: 0.5rem;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: white;border-radius: 4px;" @click.stop>
            <img style="width:0.22rem;position: absolute;top:0.2rem;right:0.2rem" src="../../../../static/close.png" alt="" @click="hideModal">
            <div style="width:100%;font-size:0.35rem;text-align: center;font-weight: bold;margin-bottom: 0.4rem;color:black;">请输入图形验证码</div>
            <div style="display:flex;border: 1px solid #aaa;border-radius: 4px;overflow:hidden;">
                <input
                    v-model="verifyCode"
                    placeholder="请输入验证码"
                    style="width:3rem;height:0.64rem; margin: 0;outline: 0;border: 0;font-size: 0.32rem;line-height: 0.64rem;padding: 0 0 0 0.15rem;"
                >
                <img v-if="verify.VerifyType == '1'" v-on:click="getVerifyImgCode()" :src="'data:image/png;base64,'+verify.VerifyCode" alt="">
            </div>
            <div style="width: 100%;font-size: 0.28rem;line-height: 0.28rem;text-align: center;margin-top: 0.4rem;padding: 0.22rem 0;background-color: #ff944b;
                border-radius: 0.6rem;
                color: white;" @click="APPDownloadCount2">确认</div>
        </div>
    </div>

  </div>
</template>


<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../../api";

export default {
  data() {
    return {
      ysf: false,
      scope: "scope.mobile",
      cardNo: "",
      sign: "",
      code: "",
      openId: "",
      refuseAuth: false,

      activeTab: "tab1",

      //  输入框初始化 1
      UserName: "",
      UserPass: "",
      haorem: true,
      FJM1: "",

      FJMPD: false,

      //  输入框初始化  END

      //  附加码图片
      TPFJM: "",

      //  输入框初始化 2
      UserPhone: "",
      YZM: "",
      //  输入框初始化  END  2

      // 弹出层 弹出内容
      toast: false,
      TellUser: "",
      // 弹出层 弹出内容  END

      haveYZM: false,
      WaitTime: "",
      Time: 59,

      urls: "",
      //网易云盾验证码
      validate: "",

      showVerifyCode:false,
      verifyCode:"",
      verify: {
          CodeGuid:"",
          VerifyCode:"",
          VerifyType:0,
      },

      //屏幕宽度
      WinWidth: document.body.clientWidth,
      //  popDisplayA: false,
      // popOnlyOk: false,
      // popMsg: "未激活无法进行预定，是否先激活",
      // cardname:'',
      // cardphone:'',
      // cardkind:'',
      // cardno:'',
      //用户侧公网IP
      ip_address: returnCitySN["cip"],
      btLoading:false
    };
  },

  //进入时运作
  activated() {
    this.FJM1 = "";
    //20180727 xulong  wifi跳转页面默认跳转
    if (this.$route.query.usr != undefined) {
      this.UserPhone = this.$route.query.usr; //获取转入参数 手机号码
    }
    if (this.$route.query.activeTab != undefined) {
      this.activeTab = this.$route.query.activeTab; //获取转入参数 手机号码
    }

    this.getValidateCode();
    // this.CheckLogin();   登录页循环判定是否登录，先不放

    let that = this;
    _fmOpt.onSuccess = function (validateToken) {
        
        var params = new that.URLSearchParam();
        params.append("phoneNo", that.UserPhone);
        params.append("captcha", validateToken);
        
        that.$http.post(api.getYdSMSLoginCode2(), params.toParam()).then(res => {
          if (res.Result == true) {
            that.TellUser = "验证码已发送";

            that.haveYZM = true;
            that.WaitTime = this.Time + "秒";
            that.timer();

          } else {
            // 失败
            that.TellUser = res.Message;
          }
          that.showToast();
        });
    }
  },

  created() {
    // 判断是不是云闪付，显示云闪付登陆界面
    var newUrltype = sessionStorage.getItem(
      window.location.hostname + "_hometype"
    );
    if (
      newUrltype != null &&
      newUrltype != undefined &&
      newUrltype != "" &&
      newUrltype.search("ysf") != -1
    ) {
      this.ysf = true;
    }

    if (this.$route.query.type == "ysf") {
      this.ysf = true;
    }
    this.getUnionLoginUrl();
    this.getVerifyImgCode();
  },

  mounted() {
    document.title = "格林";
    var that = this;
    upsdk.pluginReady(function () {
      upsdk.registerLifecycle({
        onAppShow: function () {
          // 小程序显示
          // upsdk.showFlashInfo({
          //   msg: "小程序显示",
          // });
        },
        onAppHide: function () {
          // 小程序隐藏
          // upsdk.showFlashInfo({
          //   msg: "小程序隐藏",
          // });
        },
        onAppLoad: function () {
          // 小程序加载
          // upsdk.showFlashInfo({
          //   msg: "小程序加载",
          // });
        },
        onPageBack: function () {
          console.log("点击返回按钮");
          // 点击返回按钮
          upsdk.showFlashInfo({
            msg: "点击返回按钮",
          });
        },
      });

      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色。
        navBackgroundColor: "0x8FFFFFFF",
        appletStyle: "black", //可选，black-黑色主题，white-白色主题。
        backBtnVisible: "0", // 可选，左侧返回按钮是否显示。’0’不显示，’1’显示，不传或空则默认显示
        appletTitleBarVisible: "1", // 可选，标题栏是否显示。’0’不显示，’1’显示，默认显示
      });

      upsdk.queryData({
        key: "userinfo",
        success: function (result) {
          //result = {code:'',msg:'',key:'xxx',value:'xxx'}
          console.log("queryData-------");
          console.log(result.value.card_no + "sign" + result.value.sign);
          //that.cardNo = result.value.card_no;
          if (result.value.card_no != null && result.value.card_no != "") {
            var urlString = that.COMMON.h5url;
            "?cardNo=" +
              result.value.card_no +
              "&sign=" +
              result.value.sign +
              "&type=ysf";
            console.log("本地存储" + urlString);
            //window.location.href = urlString;
          }
        },
      });
      // upsdk.appletAuth({
      //   success: function (data) {
      //     console.log("code...." + data.code);
      //     that.code = data.code;
      //     this.$http
      //       .post(api.gethttpUrl() + "/Login/UnionPayUserLogin", {
      //         Code: data.code,
      //       })
      //       .then(function (response) {
      //         console.log(response.data);
      //         that.cardNo =
      //           response.data.data.card_no != null
      //             ? response.data.data.card_no
      //             : "";
      //         that.sign =
      //           response.data.data.sign != null ? response.data.data.sign : "";
      //         that.openId = response.data.data.openId;
      //         upsdk.saveData({
      //           key: "userinfo",
      //           value: response.data.data,
      //           success: function (result) {
      //             console.log("result.code" + result.code);
      //           },
      //         });
      //         upsdk.queryData({
      //           key: "userinfo",
      //           success: function (result) {
      //             //result = {code:'',msg:'',key:'xxx',value:'xxx'}
      //             console.log(result.value);
      //           },
      //         });

      //         if (that.cardNo != null && that.cardNo != "") {
      //           var urlString =
      //             api.geth5Url() +
      //             "?cardNo=" +
      //             that.cardNo +
      //             "&sign=" +
      //             that.sign +
      //             "&type=ysf";
      //           console.log("静默授权" + urlString);
      //           window.location.href = urlString;
      //         }
      //       })
      //       .catch(function (error) {
      //         console.log(error);
      //       });
      //     // }
      //   },
      //   fail: function (error) {
      //     // error={errcode:’xxx’, errmsg:’xxx’}
      //   },
      // });
    });
  },

  // 数据获取
  computed: {
    ...mapGetters(["g_UserInfo", "g_loginInfo"]),
  },
  methods: {
    ...mapMutations(["setG_UserInfo", "setG_loginInfo"]),

    // 云闪付一键登录
    btnClick(event, err, result) {
      console.log(event, err, result);
      var that = this;
      console.log("-------" + result);
      that.btLoading = true
      that.$http
        .post(api.GetUnionPayBindPhone(window.location.host), {Code:result.code})
        .then((response) => {
          console.log("cardNO---:" + response.Data.Card_no);
          that.cardNo =
          response.Data.Card_no != null ? response.Data.Card_no : "";
          that.sign = response.Data.Sign != null ? response.Data.Sign : "";
        
          var params = new that.URLSearchParam();
          params.append("userId",  that.cardNo);
          params.append("sign", that.sign);
          console.log("params-------" + params);
          that.$http
            .post(api.CheckLoginState(), params.toParam())
            .then((data) => {
              that.btLoading = false
              if (data.Result) {
                // 自动登入成功--保存登录信息
             
                that.loginState = true;
                console.log("========测试========");
                console.log(that.loginState);
                var result = data.Data;
                that.SaveUserInfo(result);
              }
            });
        });

      // this.$http
      //   .post(api.gethttpUrl() + "/Login/UnionPayBindPhone", {
      //     Code: "result.code",
      //   })
      //   .then(function (response) {
      //     debugger;
      //     console.log("cardNO---:" + response.data.data.card_no);
      //     that.cardNo =
      //       response.data.card_no != null ? response.data.card_no : "";
      //     that.sign = response.data.sign != null ? response.data.sign : "";
      //     var params = new that.URLSearchParam();
      //     params.append("userId", "1001100000043646");
      //     params.append("sign", "eVklv9oDmMVYvyF3HBVK7J64dfOugK0I");
      //     console.log("params-------" + params);
      //     that.$http
      //       .post(api.CheckLoginState(), params.toParam())
      //       .then((data) => {
      //         if (data.Result) {
      //           debugger;
      //           // 自动登入成功--保存登录信息
      //           that.loginState = true;
      //           console.log("========测试========");
      //           console.log(that.loginState);

      //           var result = data.Data;
      //           that.SaveUserInfo(result);
      //         }
      //       });

      //     // var urlString =
      //     //   api.geth5Url() +
      //     //   "?cardNo=" +
      //     //   that.cardNo +
      //     //   "&sign=" +
      //     //   that.sign +
      //     //   "&type=ysf";
      //     // console.log("手动授权" + urlString);
      //     // window.location.href = urlString;
      //     // upsdk.createWebView({
      //     //   url: urlString, // 新webview容器中运行的目标页面地址
      //     //   isFinish: "0", //是否关闭当前的窗口,'1':关闭，'0':不关闭
      //     // });
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    },

    // 图片验证码
    getValidateCode() {
      // 用户已登录
      if (this.g_UserInfo.Card_no) {
        // console.log(this.g_UserInfo)
        this.$router.replace({ path: "/user/UserCenter" });
      } else {
        this.TPFJM = api.getValidateCode();
        this.InitNetEaseDun();
      }
    },

    //获取验证方式
    getVerifyImgCode() {
        this.$http.get(api.getVerifyImgCode()).then(res => {
            if (res.Result == true) {
                this.verify = res.Data;
            } else {
            // 失败
                this.TellUser = res.Message;
            }
        });
    },

    // 常规登陆方式
    Login1() {
      this.UserName = this.UserName.trim();
      this.UserPass = this.UserPass.trim();
      this.FJM1 = this.FJM1.trim();
      if (this.UserName == "") {
        this.TellUser = "请输入用户名";
        this.showToast();
      } else if (this.UserPass == "") {
        this.TellUser = "请输入密码";
        this.showToast();
      } else {
        var params = new this.URLSearchParam();
        params.append("userName", this.UserName);
        params.append("password", this.UserPass);
        params.append("captcha", this.FJM1);
        params.append("black_box", encodeURI(_fmOpt.black_box));
        params.append("ip_address", this.ip_address);

        this.$http.post(api.SignIn(), params.toParam()).then((res) => {
          if (res.Result == true) {
            //激活
            //   if(!res.Data.IsActivated){
            //    this.popDisplayA = true;

            // this.popMsg = "会员卡未激活，不支持预定，前往激活";
            // this.cardkind=res.Data.Card_Kind_Diplay;
            // this.cardname=res.Data.Name;
            // this.cardno=res.Data.Card_no;
            // this.cardphone=res.Data.Phone;
            // }
            // 保存登录信息 + 跳转
            this.SaveUserInfo(res.Data);
            var loginInfo = this.g_loginInfo;
            loginInfo.Card_no = res.Data.Card_no;
            this.setG_loginInfo(loginInfo);

            // 20171219把后跳加回来  不要，是因为， SaveUserInfo 这里面有后退。
            // this.goback()
          } else {
            //登陆失败
            this.TellUser = res.Message;
            this.showToast();

            this.getValidateCode();

            //  三次密码错误后，提示需要输入验证码。显示验证码模块
            if (res.Message == "密码错误次数超出限制") {
              this.FJMPD = true;
            }

            if (this.TellUser == "需要强制改密") {
              this.TellUser = "您的账号存在安全隐患，请您立即重置密码。";
              setTimeout(() => {
                this.$router.push({ path: "/user/ForgotPass" });
              }, 2200);
            }
          }
        });
      }
    },

    SaveUserInfo(result) {
      // 保存登录信息
      // 保存登录信息
      var UserInfo = result;

      if (UserInfo.Card_Kind_Diplay == "网上数字卡") {
        UserInfo.Card_Kind_Diplay = "数字卡";
      }

      UserInfo.OrderRefresh1 = true;
      UserInfo.OrderRefresh2 = true;
      UserInfo.OrderRefresh3 = true;

      // 保存登录信息
      this.setG_UserInfo(UserInfo);

      this.UserName = "";
      this.UserPass = "";
      this.FJM1 = "";
      this.YZM = "";
      console.log('云闪付用户信息：'+result);
      if (this.$route.query.backURL) {
        // this.$router.push({ path: this.$route.query. });
        window.location.href = this.$route.query.backURL;
      } else {
        this.goback();
      }
    },

    // 常规登陆方式  END

    //  获取验证码
    getYZM() {
      if (this.UserPhone == "") {
        this.TellUser = "请输入手机号";
        this.showToast();
      } else {
        this.haveYZM = true;
        this.WaitTime = this.Time + "秒";
        this.timer();
      }
    },
    timer() {
      if (this.Time > 0) {
        this.Time--;
        this.WaitTime = this.Time + "秒";

        setTimeout(this.timer, 1000);
      } else if (this.Time == 0) {
        this.haveYZM = false;
        this.Time = 59;
      }
    },
    //手机短信验证码
    getSmsYZM() {
      if (this.UserPhone == "") {
        this.TellUser = "请输入手机号";
        this.showToast();
      } else {
        this.haveYZM = true;
        this.WaitTime = this.Time + "秒";
        this.timer();
      }
      var params = new this.URLSearchParam();
      params.append("phoneNo", this.UserPhone);
      params.append("captcha", this.validate);

      this.$http.post(api.getYdSMSLoginCode(), params.toParam()).then((res) => {
        window.captchaInsD.refresh(); //清理验证码
        if (res.Result == true) {
          this.TellUser = res.Data;
          this.showToast();
        } else {
          // 失败
          this.TellUser = res.Message;
          this.showToast();
          this.FJM1 = "";
          this.Time = 5;
        }
      });
    },
    //   closePop() {
    //   this.popDisplayA = false;
    // },
    // closeYESA() {
    //   this.popDisplayA = false;
    //    console.log(this.cardphone);
    //    this.$router.push({ path: "/user/activation?cardkind="+this.cardkind+"&cardno="+this.cardno+"&cardphone="+this.cardphone+"&cardname="+this.cardname})
    // //  this.$router.push({ path: "/user/activation",params:{cardkind:this.cardkind,cardno:this.cardno,cardphone:this.cardphone,cardname:this.cardname}});
    // },
    //  快捷登录
    QuickLogin() {
      if (this.UserPhone == "") {
        this.TellUser = "请输入手机号";
        this.showToast();
      } else if (this.Verification2 == "") {
        this.password = "请输入附加码";
        this.showToast();
      } else if (this.YZM == "") {
        this.TellUser = "请输入动态密码";
        this.showToast();
      } else {
        var params = new this.URLSearchParam();
        params.append("phoneNo", this.UserPhone);
        params.append("captcha", this.FJM1);
        params.append("validateCode", this.YZM);
        params.append("black_box", encodeURI(_fmOpt.getinfo()));
        params.append("ip_address", this.ip_address);

        //  快捷登录
        this.$http.post(api.GOQuickLogin(), params.toParam()).then((res) => {
          if (res.Result == true) {
            //激活
            //   if(!res.Data.IsActivated){
            //    this.popDisplayA = true;
            // this.popMsg = "会员卡未激活，不支持预定，前往激活";
            // this.cardkind=res.Data.Card_Kind_Diplay;
            // this.cardname=res.Data.Name;
            // this.cardno=res.Data.Card_no;
            // this.cardphone=res.Data.Phone;
            // }
            var result = res.Data;
            // 保存登录信息
            this.SaveUserInfo(result);
            var loginInfo = this.g_loginInfo;
            loginInfo.Card_no = res.Data.Card_no;
            this.setG_loginInfo(loginInfo);

            //this.goback()
          } else {
            //登陆失败
            this.TellUser = res.Message;
            this.showToast();

            if (this.TellUser == "需要强制改密") {
              this.TellUser = "您的账号存在安全隐患，请您立即重置密码。";
              setTimeout(() => {
                this.$router.push({ path: "/user/ForgotPass" });
              }, 2200);
            }
          }
        });
      }
    },
    //  快捷登录  END

    handleTabChange(val) {
      this.activeTab = val;
      if (val == "tab2") {
      }
    },

    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 2500);
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    // 弹出层  end

    // 弹出标签 选择是否
    open() {
      this.dialog = true;
    },
    closeYES() {
      this.dialog = false;
      //调用弹出层
      this.showToast();
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否

    // 后退一页
    goback() {
      javascript: history.go(-1);
      //this.$router.go(-1)
      //console.log('i come')
    },

    getUnionLoginUrl() {
      this.$http.post(api.getUnionLoginUrl()).then((res) => {
        this.urls = res.Data;
        console.log(this.urls);
      });
    },
    //初始化易盾
    InitNetEaseDun() {
      if (window.captchaInsD != undefined) {
        return;
      }
      //网易云盾初始化
      var that = this;
      var captchaIns;
      var winWidth = this.WinWidth <= 320 ? "auto" : "280";
      initNECaptcha(
        {
          element: "#captcha",
          captchaId: "883464f032c9481a891b5fb9fb49bd23",
          mode: "popup",
          width: winWidth,
          onVerify: function (err, data) {
            if (
              err != undefined ||
              data == undefined ||
              data.validate == undefined
            ) {
              that.validate = "";
              that.TellUser = "验证有误！请重新验证";
              that.toastTimer = 5;
              that.showToast();
              return;
            }
            that.validate = data.validate;
            that.getSmsYZM();
          },
        },
        function (instance) {
          // 初始化成功后得到验证实例instance，可以调用实例的方法
          captchaIns = instance;
          window.captchaInsD = captchaIns;
        },
        function (err) {
          // 初始化失败后触发该函数，err对象描述当前错误信息
        }
      );
    },
    NetEaseDunClick() {
      if (this.UserPhone == "") {
        this.TellUser = "请输入手机号";
        this.showToast();
      } else if (this.UserPhone.length != 11) {
        this.TellUser = "手机号格式不正确";
        this.showToast();
      } else {
          if (this.verify.VerifyType == 1) {
                //自研
                this.getVerifyImgCode();
                this.showVerifyCode = true;
            }
            if (this.verify.VerifyType == 2) {
                //同盾
                _fmOpt.triggerCaptcha();
            }
            if (this.verify.VerifyType == 3) {
                //易盾
                if (this.validate.length > 0) {
                    window.captchaInsD.refresh();
                }
                window.captchaInsD.popUp();
            }
      }
    },


    hideModal() {
        this.showVerifyCode = false;
    },

    APPDownloadCount2() {
        if (this.verifyCode.length < 4) {
            return
        }
        var params = new this.URLSearchParam();
        params.append("phoneNo", this.UserPhone);
        params.append("captcha", this.verifyCode);
        params.append("codeGuid", this.verify.CodeGuid);
        
        this.$http.post(api.getYdSMSLoginCode2(), params.toParam()).then(res => {
          if (res.Result == true) {
            this.TellUser = "验证码已发送";
            this.showVerifyCode = false;
            this.verifyCode = "";

            this.haveYZM = true;
            this.WaitTime = this.Time + "秒";
            this.timer();
          } else {
            // 失败
            this.getVerifyImgCode();
            this.TellUser = res.Message;
          }
          this.showToast();
        });
    },
  },
};
</script>


<style lang="less" >
.pageContent .mu-appbar-title {
  text-align: center;
  margin-top: -10px;
}

#HelloWorld {
  height: 100%;
  margin: 0 auto;
}
.pages {
  background-image: url("https://weapp.998.com/images/center/bind_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  /* width: 750px; */
  height: 100%;
  position: relative;
}

.loading{
    position: absolute;

    margin: auto;

    top: 40%;

    left: 45%;
  }

.login-bg {
  position: absolute;
  z-index: 1;
  width: 750px;
  height: 600px;
}

#btnClick1 {
  position: absolute;
  top: 75%;
  left: 50%;
  margin-left: -1.5rem;
  margin-top: -1.2rem;
  text-align: center;
  width: 3rem;
  height: 1rem;
  background: linear-gradient(189deg, #ff8b46 0%, #ff6427 100%);
  color: #fff;
  font-size: 0.3rem;
  border-radius: 0.44rem;
  line-height: 0.88rem;
}

#btnLogin {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1.5rem;
  margin-top: -1.2rem;
  text-align: center;
  width: 3rem;
  height: 1rem;
  background: linear-gradient(189deg, #ff8b46 0%, #ff6427 100%);
  color: #fff;
  font-size: 0.3rem;
  border-radius: 0.44rem;
  line-height: 0.88rem;
}

@import "../../../assets/theme.less"; // 顶部标签变换
.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
.pageContent {
  max-width: 480px; // margin-left: auto;
  // margin-right: auto;
  // text-align: center;
  .bigpage {
    width: 80%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor;
  }

  .Black {
    color: @primaryBlack;
  }

  .Grey {
    color: @textColor;
  } // .txtValidate {
  //   .mu-text-field-content {
  //     .mu-text-field-hint {
  //       width: 120px;
  //      border:1px dashed #000;
  //     }
  //   }
  // }
  .mu-tabs {
    background-color: #fff;
    .mu-tab-link {
      color: @greyFontColor;
    }
    .mu-tab-active {
      color: @primaryColor;
    }
    .mu-text-field-line {
      background-color: #fff;
    }
  }
}
.unionLogin {
  margin-bottom: 56px;
  clear: both;
  .top {
    color: #999999;
    font-size: 0.3rem;
    display: flex;
    justify-content: center;
    margin: 2rem 0.6rem 0 0.6rem;
    .line {
      border-top: 1px solid #cccccc;
      height: 0px;
      margin: auto 0.1rem;
      flex-grow: 1;
    }
  }
  .btns {
    margin-top: 0.52rem;
    display: flex;
    justify-content: center;
    img {
      width: 0.8rem;
      height: 0.8rem;
    }
    .center {
      margin: 0 0.5rem;
    }
  }
}

#circle{

    margin: 20px auto;

    width: 50px;

    height: 50px;

    border: 5px white solid;

    border-left-color: #3ee72e;

    border-right-color:#3ee72e;

    border-radius: 100%;

    animation: loading1 1s infinite linear;

}

@keyframes loading1{

    from{transform: rotate(0deg)}to{transform: rotate(360deg)}

}
</style>






// WEBPACK FOOTER //
// Login.vue?c88e99b0